// "or similar" suffix for vehicle model names (replaces the old hardcoded German "o. ä.").
export const VEHICLE_STRINGS = {
  de: { veh_or_similar: "o. ä." },
  en: { veh_or_similar: "or similar" },
  fr: { veh_or_similar: "ou similaire" },
  it: { veh_or_similar: "o simili" },
  es: { veh_or_similar: "o similar" },
  pt: { veh_or_similar: "ou similar" },
  ru: { veh_or_similar: "или аналог" },
  ar: { veh_or_similar: "أو ما شابه" },
  fa: { veh_or_similar: "یا مشابه" },
  hi: { veh_or_similar: "या समकक्ष" },
  zh: { veh_or_similar: "或同级车型" },
  ko: { veh_or_similar: "또는 동급 차량" },
  ckb: { veh_or_similar: "یان هاوشێوە" },
  tr: { veh_or_similar: "veya benzeri" },
};
